
function InputField({ name, placeholder, handleChange, value, option, ...rest }) {
    return (
        <div
            className={
                "input input-bordered flex flex-row item-center justify-between w-full h-11 py-0  text-base font-normal"
            }
        >
            <input
                className={
                    "block w-full px-3 text-sm font-normal border border-black rounded-md leading-normal bg-transparent focus:bg-transparent focus:border focus:border-black"
                }
                name={name || null}
                value={value}
                onChange={handleChange}
                placeholder={placeholder || ""}
                {...rest}
            />
        </div>
    )
}

export default InputField